import React from 'react'
import { Box, Text } from '@chakra-ui/react'

import { ListProps } from './interfaces'
import { ListItem } from './ListItem'

export const List: React.FC<ListProps> = ({ data, title, children, ...boxProps }) => {
  return (
    <Box {...boxProps}>
      {title && (
        <Text color="black" fontSize="xs" marginY="12px">
          {title}
        </Text>
      )}
      {data?.map(({ name, value }, index) => (
        <ListItem key={`${name}_${value}-${index}`} name={name} value={value} />
      ))}
      {children}
    </Box>
  )
}

export * from './ListItem'
